import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.t('详情'),
      "data-sign": "finance_domestic_statement_details_modal",
      "width": 800,
      "wrap-class-name": "modal-body"
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('div', {
    staticClass: "mb-10 most-big-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('基本信息')))])]), _c('my-table', {
    staticClass: "mt-10",
    attrs: {
      "bordered": "",
      "data-sign": "finance_domestic_statement_details_base_info",
      "columns": _vm.columns,
      "data-source": _vm.dateilBaseInfo || [],
      "rowKey": function (record, index) {
        return index;
      },
      "pagination": false
    }
  }), _c('a-tabs', {
    staticClass: "mb-10",
    attrs: {
      "size": "small",
      "animated": false
    },
    model: {
      value: _vm.activeName,
      callback: function ($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, _vm._l(_vm.tabList, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "tab": item.text
      }
    });
  }), 1), _c(_vm.activeName, {
    tag: "component",
    attrs: {
      "detailsData": _vm.detailsData
    }
  })], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "fbu-analyse-name": $t("\u5173\u95ED")
    },
    on: {
      "click": function ($event) {
        return _vm.handleClose();
      }
    }
  }, [_vm._v(_vm._s(_vm.t('关闭')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };